import {FC, Card, PropsWithChildren, useMemo} from 'external/react'
import Icon, {IconName} from 'external/fortawesome'

import ButtonBack from 'components/ButtonBack'
import useParent from 'context/parent-context/hook'

import BasicLayout from './BasicLayout'

const NewUserContainer: FC<PropsWithChildren> = props => {
    const {children} = props
	const {params, navigation} = useParent()
    
    const [iconName, roleText, backLink] = useMemo(() => [
        params.role === 'student' ? 'faGraduationCap' : 'faPersonChalkboard',
        params.role === 'student' ? 'estudiante' : 'tutor',
        navigation.users.link()
    ] as [IconName, string, string], [params.role])

    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path={backLink} />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name={iconName} /> Nuevo {roleText}
                </div>
            </Card.Header> 
            {children}
        </BasicLayout>
    )
}

export {NewUserContainer as default}